import React, { useEffect, useState } from "react";
import { Input, Modal, Radio } from "antd";
import style from "./style.scss";

import { getWindowHeight } from "../../../../../services";

import ReversedRadio from "./ReversedRadio";
import SingleSelectHeader from "./SingleSelectHeader";

const MaxItem = 6;
const ItemHeight = 50;
const Padding = 73;

const SingleSelectModal = props => {
  const { value, visible, onCancel, options, title } = props;

  const [visibleOptions, setVisibleOptions] = useState([]);

  useEffect(() => {
    resetVisibleOptions();
  }, [JSON.stringify(options)]);

  const resetVisibleOptions = () => {
    const { options } = props;
    const visibleOptions = [...options];

    setVisibleOptions(visibleOptions);
  };

  const handleFilterChange = e => {
    const { options } = props;
    const { value } = e.target;
    const filteredOptions = options.filter(o =>
      o.title.toLowerCase().includes(value.toLowerCase())
    );

    setVisibleOptions(filteredOptions);
  };

  const handleChange = e => {
    const { value } = e.target;
    const { onChange, onCancel } = props;
    onChange(value);
    onCancel();
  };

  const afterClose = () => {
    resetVisibleOptions();
  };

  const windowHeight = getWindowHeight();

  return (
    <Modal
      afterClose={afterClose}
      destroyOnClose
      closable={false}
      onCancel={onCancel}
      footer={null}
      visible={visible}
      style={{
        paddingBottom: 0,
        paddingTop: 0,
        marginBottom: 0,
        marginTop: 0,
        top:
          options.length > MaxItem
            ? (windowHeight - MaxItem * ItemHeight) / 2 - Padding
            : (windowHeight - options.length * ItemHeight) / 2 - Padding
      }}
    >
      <SingleSelectHeader title={title} onCancel={onCancel} />
      {options.length > MaxItem ? (
        <Input placeholder="Filter" onChange={handleFilterChange} />
      ) : null}
      <Radio.Group
        value={value}
        style={{ maxHeight: MaxItem * ItemHeight }}
        onChange={handleChange}
        className={style.itemGroup}
      >
        {visibleOptions.map(option => (
          <div key={option.value} className={style.item}>
            <ReversedRadio
              value={option.value}
              label={option.title}
              color={option.color}
            />
          </div>
        ))}
      </Radio.Group>
    </Modal>
  );
};

SingleSelectModal.defaultProps = {
  visible: false,
  value: null,
  title: ""
};

export default SingleSelectModal;



// WEBPACK FOOTER //
// ./src/components/FormControls/SingleColorSelector/MobileDropdownSelect/SingleSelectModal/index.tsx